<template>
  <div class="paga" style="height: 100%">
    <div v-loading="loading">
      <!-- 搜索框 -->
      <div class="search-section" style="margin-bottom: 10px;">
        <el-form size="small" label-width="100px" class="margin15-tb">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="策略组ID">
                <el-input clearable v-model="searchForm.groupId" placeholder="请输入策略组ID" @input="validateGroupId"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="策略组名称">
                <el-input clearable v-model="searchForm.groupName" placeholder="请输入策略组名称"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div class="text left">
                <el-button type="primary" size="mini" @click="handleSearch" icon="el-icon-search">搜索</el-button>
                <el-button size="mini" @click="handleReset" icon="el-icon-refresh">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 操作按钮区域 -->
      <div style="margin-bottom: 10px;">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-button type="primary" @click="add" v-if="permission">
              <i class="el-icon-circle-plus"></i> 添加策略组
            </el-button>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-radio-group v-model="viewType" size="small">
              <el-radio-button label="list">
                <i class="el-icon-document"></i> 列表视图
              </el-radio-button>
              <el-radio-button label="card">
                <i class="el-icon-menu"></i> 卡片视图
              </el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>

      <!-- 卡片视图 -->
      <el-row :gutter="24" v-if="viewType === 'card'" style="height: calc(100% - 60px); overflow-y: auto;">
        <el-col v-for="item in groupOption" :key="item.groupId" :span="8">
          <el-card shadow="hover" style="height: 200px;border:1px solid #303133;">
            <span style="font-weight:bold">{{item.groupName + '(' + item.groupId + ')'}}</span>
            <el-tag type="success" style="float:right" v-if="item.percentage>0">使用中</el-tag>
            <el-tag type="info" style="float:right" v-if="item.percentage===0">未使用</el-tag>
            <br>
            <br>
            <div style="text-align:center;">
              首发方式&nbsp;<span style="font-size:100%;font-weight:bold">{{formatSendWay(item.sendWay)}}</span>
              首发模板&nbsp;<span style="font-size:100%;font-weight:bold">{{formatTemplateName(item)}}</span>
              每日语音发送上限&nbsp;<span style="font-size:100%;font-weight:bold">{{item.ivrSendCeiling}}条</span>
              每日语音接听上限&nbsp;<span style="font-size:100%;font-weight:bold">{{item.ivrCeiling}}条</span>
              每日短信上限&nbsp;<span style="font-size:100%;font-weight:bold">{{item.msgCeiling}}条</span>
              <template v-if="$partB()">
                <template v-if="item.msgIsRetry">
                  短信重发次数&nbsp;<span style="font-size:100%;font-weight:bold">{{item.msgRetryCount}}次</span>
                </template>
                <template v-if="item.isRetry">
                  重呼次数&nbsp;<span style="font-size:100%;font-weight:bold">{{getRetryCount(item)}}次</span>
                </template>
                <template v-if="getMockConfIsMock(item)">
                  比例预警&nbsp;<span style="font-size:100%;font-weight:bold">{{getMockConfRate(item)}}</span>
                </template>
              </template>
            </div>
            <div style="margin-top:40px">
              <el-button type="primary" size="mini" @click="openSendRule(item.groupId)" round>查看策略</el-button>
              <el-button type="primary" size="mini" @click="copyStrategy(item)" v-if="permission" round>复制到新策略</el-button>
              <el-button type="primary" size="mini" @click="updateStrategy(item)" v-if="permission" round>编辑策略组</el-button>
              <el-button type="primary" size="mini" @click="routeStrategy(item)" v-if="permission" round>路由策略组</el-button>
              <el-button type="primary" size="mini" @click="deleteStrategy(item.groupId)" v-if="permission && item.groupName !== '主策略组'" round>删除策略组</el-button>
            </div>
            <div class="text right">
              <span style="position:relative;top: 5px;">更新时间：{{item.updateTime}}</span>
            </div>
          </el-card>
          <br>
        </el-col>
      </el-row>

      <!-- 列表视图 -->
      <div v-else style="height: calc(100% - 60px); display: flex; flex-direction: column;">
        <el-table
          :data="groupOption"
          style="width: 100%; flex: 1;"
          border
          :row-style="{ height: '50px' }"
          :cell-style="{ padding: '5px 0' }">
          <el-table-column prop="groupName" label="策略组名称" min-width="200">
            <template slot-scope="scope">
              {{scope.row.groupName + '(' + scope.row.groupId + ')'}}
            </template>
          </el-table-column>
          <el-table-column prop="percentage" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.percentage>0">使用中</el-tag>
              <el-tag type="info" v-if="scope.row.percentage===0">未使用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="followUpDays" label="首发方式" min-width="120">
            <template slot-scope="scope">
              <span>{{formatSendWay(scope.row.sendWay)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="averageFollowMsg" label="首发模板" min-width="120">
            <template slot-scope="scope">
              <span>{{formatTemplateName(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="averageFollowIvr" label="每日语音发送上限" min-width="120">
            <template slot-scope="scope">
              <span>{{scope.row.ivrSendCeiling}}条</span>
            </template>
          </el-table-column>
          <el-table-column prop="averageFollowIvr" label="每日语音接听上限" min-width="120">
            <template slot-scope="scope">
              <span>{{scope.row.ivrCeiling}}条</span>
            </template>
          </el-table-column>
          <el-table-column prop="averageFollowIvr" label="每日短信上限" min-width="120">
            <template slot-scope="scope">
              <span>{{scope.row.msgCeiling}}条</span>
            </template>
          </el-table-column>
          <template v-if="this.$partB()">
            <el-table-column prop="averageFollowIvr" label="短信重发次数" min-width="120" v-if="hasAnyMsgRetry">
              <template slot-scope="scope">
                <span v-if="scope.row.msgIsRetry">{{scope.row.msgRetryCount}}次</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="averageFollowIvr" label="重呼次数" min-width="120" v-if="hasAnyIsRetry">
              <template slot-scope="scope">
                <span v-if="scope.row.isRetry">{{getRetryCount(scope.row)}}次</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="averageFollowIvr" label="比例预警" min-width="120" v-if="hasAnyMockConf">
              <template slot-scope="scope">
                <span v-if="getMockConfIsMock(scope.row)">{{getMockConfRate(scope.row)}}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="updateTime" label="更新时间" min-width="180"></el-table-column>
          <el-table-column label="操作" min-width="550" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openSendRule(scope.row.groupId)" round>查看策略</el-button>
              <el-button type="primary" size="mini" @click="copyStrategy(scope.row)" v-if="permission" round>复制到新策略</el-button>
              <el-button type="primary" size="mini" @click="updateStrategy(scope.row)" v-if="permission" round>编辑策略组</el-button>
              <el-button type="primary" size="mini" @click="routeStrategy(scope.row)" v-if="permission" round>路由策略组</el-button>
              <el-button type="primary" size="mini" @click="deleteStrategy(scope.row.groupId)" v-if="permission && scope.row.groupName !== '主策略组'" round>删除策略组</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['reload'],
  props: [
    'changeTabe',
    'companySelected',
    'updateGroup'
  ],
  data() {
    return {
      startTime: null,
      companyId: null,
      groupOption: [],
      groupLength: 0,
      loading: true,
      permission: true,
      viewType: 'list', // 视图类型控制（当前为列表视图），若修改为卡片视图，则将list改为card
      searchForm: {
        groupId: '',
        groupName: ''
      },
      originalGroupOption: [] // 用于存储原始数据
    };
  },
  computed: {
    hasAnyMsgRetry() {
      return this.groupOption.some(item => item.msgIsRetry);
    },
    hasAnyIsRetry() {
      return this.groupOption.some(item => item.isRetry);
    },
    hasAnyMockConf() {
      return this.groupOption.some(item => this.getMockConfIsMock(item));
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '策略总览') {
        this.getGroupData();
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
      // if (this.changeTabe === '策略总览') {
      //   console.warn('2222');
      //   this.getGroupData();
      // }
    }
  },
  mounted() {
    this.permission = this.$hasPerm('B032');
  },
  methods: {
    getData(companyId) {
      this.loading = true;
      this.companyId = companyId;
      this.getGroupData();
    },
    formatSendWay(value) {
      const map = {
        'C': '卡线',
        'I': '交互短信',
        'N': '通知短信',
        '0': '照比例随机发送',
        'ivr': '语音',
        'msg': '短信',
        'svoice': '场景语音',
        'ivoice': '智能语音'
      };
      return map[value] || value;
    },
    getMockConfRate(item) {
      try {
        return item.mockConf ? JSON.parse(item.mockConf).rate : item.rate;
      } catch (e) {
        return item.rate || 0; // 默认值
      }
    },
    getMockConfIsMock(item) {
      try {
        if (item.mockConf) {
          const mockConf = JSON.parse(item.mockConf);
          return mockConf.isMock === true || mockConf.isMock === 1;
        }
        return false;
      } catch (e) {
        return false;
      }
    },
    formatTemplateName(item) {
      return item.sendWay === 'svoice' && item.sceneName ? item.sceneName : item.sendTemplateName;
    },
    getRetryCount(item) {
      return item.retryCount || item.retryCountOfStrategy || 0; // 默认值
    },
    getGroupData() {
      this.$ajax({
        url: '/strategy/getGroupData',
        data: { companyId: this.companyId }
      }).then((res) => {
        this.originalGroupOption = res.data; // 保存原始数据
        this.groupOption = res.data;
        this.groupLength = res.data.length - 1;
        this.loading = false;
      });
    },
    // 查看策略按钮
    openSendRule(groupId) {
      const sessionOverview = { companyId: this.companyId, groupId };
      sessionStorage.setItem('strategyOverview', JSON.stringify(sessionOverview));
      this.reload();
    },
    // 复制到新策略
    copyStrategy(item) {
      this.$emit('refreshList', item);
    },
    // 添加策略组
    add() {
      this.$emit('refreshList', null);
    },
    // 更新策略组
    updateStrategy(item) {
      this.$emit('updateGroup', item);
    },
    // 路由策略组
    routeStrategy(item) {
      this.$emit('strategyRouteConfig', item);
    },
    // 删除策略组
    deleteStrategy(groupId) {
      this.$confirm('您确定要删除该策略组吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const h = this.$createElement;
        this.$prompt('', '提示', {
          message: h('p', null, [
            h('span', null, '请输入 '),
            h('i', { style: 'color: red' }, '我确认删除'),
            h('i', null, '后，点击确认进行删除')
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^我确认删除{0,}$/
        }).then(() => {
          this.$ajax({
            url: '/strategy/delStrategyGroup',
            params: { 'groupId': groupId },
            prompt: true
          }).then(() => {
            // 刷新
            this.getGroupData();
          });
        });
      });
    },
    // 策略组id输入类型校验 只允许数字，如果不是数字则清空
    validateGroupId(value) {
      if (value && !/^\d+$/.test(value)) {
        this.$nextTick(() => {
          this.searchForm.groupId = '';
        });
      }
    },
    // 搜索方法
    handleSearch() {
      this.loading = true;
      const searchParams = {
        companyId: this.companyId
      };
      // 如果有搜索条件，添加到参数中
      if (this.searchForm.groupId) {
        searchParams.groupId = this.searchForm.groupId;
      }
      if (this.searchForm.groupName) {
        searchParams.groupName = this.searchForm.groupName;
      }
      this.$ajax({
        url: '/strategy/getGroupData',
        data: searchParams
      }).then((res) => {
        this.originalGroupOption = res.data; // 保存原始数据
        this.groupOption = res.data;
        this.groupLength = res.data.length - 1;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 重置方法
    handleReset() {
      this.searchForm.groupId = '';
      this.searchForm.groupName = '';
      // 重置时重新获取所有数据
      this.getGroupData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/strategy_overview.vue